import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Mail } from "lucide-react";

export default function NewsletterBlock({ variant = "hero" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (variant === "hero") {
    return (
      <div className="border-2 border-black p-6 md:p-8 bg-white" data-testid="newsletter-hero">
        <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] mb-3 text-[#E63946]">
          <Mail className="w-3.5 h-3.5" strokeWidth={2} /> The Daily Deal
        </div>
        <h3 className="font-serif font-black text-2xl md:text-3xl leading-tight tracking-tight mb-2">
          One handpicked deal.<br />Every morning.
        </h3>
        <p className="text-sm text-black/60 mb-5 leading-relaxed">
          Join thousands of savvy shoppers. No spam — just the single best deal from across the web, delivered to your inbox.
        </p>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-0">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="flex-1 border border-black px-4 py-3 focus:outline-none focus:bg-black focus:text-white font-mono text-sm"
            data-testid="newsletter-email-input-hero"
          />
          <button
            type="submit"
            disabled={loading}
            className="bg-black text-white px-6 py-3 font-bold uppercase tracking-widest text-xs hover:bg-[#E63946] disabled:opacity-50"
            data-testid="newsletter-submit-hero"
          >
            {loading ? "…" : "Subscribe"}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="bg-[#111111] text-white p-10 md:p-16" data-testid="newsletter-banner">
      <div className="max-w-3xl">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] mb-3 text-[#E63946]">Never miss a drop</div>
        <h3 className="font-serif font-black text-3xl md:text-5xl leading-tight tracking-tight mb-4">
          Get tomorrow&apos;s best deal, tonight.
        </h3>
        <p className="text-white/70 mb-6 max-w-xl">
          Subscribe for one curated deal a day, hand-picked by our editors across travel, fashion, tech, and finance.
        </p>
        <form onSubmit={submit} className="flex flex-col sm:flex-row max-w-lg">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="flex-1 border border-white/40 bg-transparent px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-white font-mono text-sm"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={loading}
            className="bg-white text-black px-6 py-3 font-bold uppercase tracking-widest text-xs hover:bg-[#E63946] hover:text-white disabled:opacity-50"
            data-testid="newsletter-submit"
          >
            {loading ? "…" : "Subscribe"}
          </button>
        </form>
      </div>
    </div>
  );
}
